import React from "react";
import { createGlobalStyle } from "styled-components";
import Header from "../header";
import axios from "axios";
import { apiCall_domain } from "../api";
import Spinner from "../Spinner/Spinner";
class myRequestOrdersDetails extends React.Component {
  state = {
    loading: true,
    RequestDetails: [],
    VendorHeader: true,
  };
  componentDidMount() {
    const Headers2 = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    localStorage.getItem("serviceUseris_request") == "true"
      ? axios
          .post(
            `${apiCall_domain}/customer/mechanics/requests/details`,
            { id: localStorage.getItem("serviceUserOrdersDetailsd") },
            {
              headers: Headers2,
            },
          )
          .then((res) => {
            this.setState({ RequestDetails: res.data.data, loading: false });
          })
      : axios
          .post(
            `${apiCall_domain}/customer/mechanics/orders/details`,
            { id: localStorage.getItem("serviceUserOrdersDetailsd") },
            {
              headers: Headers2,
            },
          )
          .then((res) => {
            this.setState({ RequestDetails: res.data.data, loading: false });
          });
  }
  pushcategoryDetail(id) {
    localStorage.setItem("pushcategoryDetail", id);
    this.props.history.push("/multiVendor/categoryDetails");
  }
  pushGoogleMap(lng, lat) {
    localStorage.setItem("latmyRequestOrdersDetails", lat);
    localStorage.setItem("langmyRequestOrdersDetails", lng);

    this.props.history.push("/multiVendor/categoryDetails/location");
  }
  render() {
    const GlobalStyles = createGlobalStyle`body{
            background: #F9F9F9;
            position:relative
          }`;
    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <GlobalStyles />
            <Header
              showSearchBar={true}
              title={`سفارش ${this.state.RequestDetails.id}`}
              VendorHeader={this.state.VendorHeader}
              handelPushHomePage={this.state.handelPushHomePage}
            />
            <div className="myRequestOrdersDetailsCom">
              <div className="myRequestOrdersDetailsComTitle">
                <img src="/public/assets/icons/orderrrrrr.svg" alt="pic" />
                <span>جزئیات سفارش </span>
              </div>
              <div className="detailsOrder">
                <span className="detailsOrdertitle">وضعیت :</span>
                <span className="value">
                  {this.state.RequestDetails.status}
                </span>
              </div>
              <div className="detailsOrder">
                <span className="detailsOrdertitle">زمان درخواستی :</span>
                <span className="value">
                  {this.state.RequestDetails.full_time}
                </span>
              </div>
              <div className="detailsOrder">
                <span className="detailsOrdertitle">مدل خودرو :</span>
                <span className="value">
                  {this.state.RequestDetails.car.name}
                </span>
              </div>
            </div>
            <div className="myRequestOrdersDetailsCom">
              <div className="myRequestOrdersDetailsComTitle">
                <img src="/public/assets/icons/Vectorrrr.svg" alt="pic" />
                <span>مشکلات گزارش شده</span>
              </div>
              <div className="problems">
                {this.state.RequestDetails.problems !== undefined &&
                  this.state.RequestDetails.problems.map(
                    (Item) => " " + Item.name + " " + " _ ",
                  )}
              </div>
              <div className="userDescription">
                <span className="userDescriptionTitle">توضیحات کاربر</span>
                <div className="value">
                  {this.state.RequestDetails.description}
                </div>
              </div>
            </div>
            <div className="myRequestOrdersDetailsCom">
              <div className="myRequestOrdersDetailsComTitle">
                <img
                  src="/public/assets/icons/repair_settings_icon.svg"
                  alt="pic"
                />
                <span>سرویس دهنده</span>
              </div>
              <div className="garageName">
                <span>{this.state.RequestDetails.garage.name}</span>
                <div
                  className="img"
                  onClick={() =>
                    this.pushcategoryDetail(this.state.RequestDetails.garage.id)
                  }
                >
                  <img src="/public/assets/icons/leeeft.svg" alt="pic" />
                </div>
              </div>
              <div className="userDescription">
                <span className="userDescriptionTitle">محل ارائه سرویس</span>
                <div className="value">
                  {this.state.RequestDetails.address.address}
                </div>
              </div>
              <div className="detailsOrder detailsOrderLocationHnadle">
                <div className="detailsOrderhandle">
                  <span className="detailsOrdertitle">شماره تماس</span>
                  <span className="value">
                    {this.state.RequestDetails.address.address_phone}
                  </span>
                </div>
                <div
                  className="img"
                  onClick={() =>
                    this.pushGoogleMap(
                      this.state.RequestDetails.address.lng,
                      this.state.RequestDetails.address.lat,
                    )
                  }
                >
                  <img
                    src="/public/assets/icons/locationMulti.svg"
                    className="ImgIcon"
                    alt="pic"
                  />
                </div>
              </div>
            </div>
            <button className="buttonMyRequestOrdersDetailsCom">
              لغو سفارش
            </button>
          </>
        )}
      </>
    );
  }
}
export default myRequestOrdersDetails;
